const currentDomain = window.location.hostname;
const domainArray = currentDomain.split(".").slice(1).join(".");
export const CI_COMMIT_SHORT_SHA = import.meta.env.VITE_CI_COMMIT_SHORT_SHA;

const neoauth =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_NEOAUTH
    : `https://login.${domainArray}/`;
const appUrl =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_URL
    : `${window.location.protocol}//${window.location.hostname}/`;

const dashboard =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_DASHBOARD
    : `https://dashboard.${domainArray}/`;

const neoactivite =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_NEOACTIVITE
    : `https://neoactivite.${domainArray}/`;

const settings = {
  dashboard,
  neoauthApi: `${import.meta.env.VITE_API_NEOAUTH}`,
  centralApi: `${import.meta.env.VITE_API_CENTRALAPI}`,
  neodocsApi: `${import.meta.env.VITE_API_NEODOCS}`,
  authorizeUrl: `${neoauth}o/authorize/`,
  revokeToken: `${neoauth}o/revoke_token/`,
  clientId: `${import.meta.env.VITE_API_CLIENT_ID}`,
  redirectUri: `${appUrl}store-token/`,
  neoactivite: import.meta.env.VITE_API_NEOACTIVITE,
  neoactiviteWS: import.meta.env.VITE_API_NEOACTIVITE_WS,
  fullLoginUrl: "",
};

settings.fullLoginUrl = `${settings.authorizeUrl}?response_type=token&client_id=${
  settings.clientId
}&scope=read&redirect_uri=${appUrl}${window.location.pathname.substring(1)}${encodeURIComponent(
  window.location.search,
)}`;

export default settings;

export const APP_URL = {
  neoActiviteUrl: `${neoactivite}`,
};

export const TreeTableRow = 10;
export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";

export const dynamsoft = {
  productKey: import.meta.env.VITE_DYNAMSOFT_PRODUCTKEY,
  resourcePath: import.meta.env.VITE_DYNAMSOFT_RESOURCEPATH,
};
